import { render, staticRenderFns } from "./upgrade.vue?vue&type=template&id=17661ec4&scoped=true"
import script from "./upgrade.vue?vue&type=script&lang=js"
export * from "./upgrade.vue?vue&type=script&lang=js"
import style0 from "./upgrade.vue?vue&type=style&index=0&id=17661ec4&prod&scoped=true&lang=scss"
import style1 from "./upgrade.vue?vue&type=style&index=1&id=17661ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17661ec4",
  null
  
)

export default component.exports